<template>
    <div>


        <rkm-row class="flex-nowrap">
            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Profissional"
                    v-model="form.profissional.nome"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Data de nascimento"
                    v-model="form.profissional.dataNascimento"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="CPF"
                    disabled
                    v-model="form.profissional.cpf"
                />
            </rkm-col>
        </rkm-row>

        <Buscar
            :form="form"
            :model="model"
            :profissional="profissional"
            @handleBlur="handleBlur"
        />

        <div>

            <rkm-row v-if="model.jornadasNotSave && model.jornadasNotSave.length > 0">
                <rkm-col cols="12">
                    <rkm-area
                        type="fieldset"
                        title="ATRIBUIR PARA AS JORNADAS SELECIONADAS"
                    >
                        <rkm-form ref="RkmForm">
                            <rkm-row>
                                <rkm-col cols="3">
                                    <rkm-form-select
                                        :options="form.unidadesParametrizadas"
                                        label="Unidade"
                                        show-default-option
                                        text-field="nomeFantasia"
                                        v-model="jornada.unidadeId"
                                        value-field="unidadeId"
                                        :disabled="selecionados == false"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <rkm-form-select
                                        label="Local de atendimento"
                                        :options="infraestruturas"
                                        textField="nome"
                                        v-model="jornada.infraestruturaId"
                                        valueField="id"
                                        show-default-option
                                        :disabled="!jornada.unidadeId || selecionados == false"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <rkm-form-select
                                        :options="prestadores"
                                        label="Prestador"
                                        show-default-option
                                        text-field="nomeFantasia"
                                        v-model="jornada.prestadorId"
                                        value-field="prestadorId"
                                        :disabled="selecionados == false"
                                    />
                                </rkm-col>

                                <rkm-col cols="3">
                                    <rkm-form-select
                                        :options="form.exames"
                                        label="Grupo de exame"
                                        show-default-option
                                        text-field="nome"
                                        v-model="jornada.exameId"
                                        value-field="id"
                                        :disabled="selecionados == false"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <rkm-form-time-picker
                                        label="Horário Inicial"
                                        v-model="jornada.horaInicial"
                                        :validations="validations.horaInicial"
                                        :disabled="selecionados == false"
                                        @input="handleBlurHoraFim"
                                        @change="handleBlurHoraFim"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <rkm-form-time-picker
                                        label="Horário Final"
                                        v-model="jornada.horaFim"
                                        :validations="validations.horaFim"
                                        :disabled="selecionados == false"
                                        @input="handleBlurHoraFim"
                                        @change="handleBlurHoraFim"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <rkm-form-select
                                        :options="form.status"
                                        label="Status"
                                        show-default-option
                                        text-field="nome"
                                        v-model="jornada.statusId"
                                        value-field="id"
                                        :disabled="selecionados == false"
                                    />
                                </rkm-col>

                                <rkm-col cols="2">
                                    <rkm-form-input
                                        label="Número de vagas"
                                        v-model="jornada.vagas"
                                        :disabled="selecionados == false"
                                        :validations="validations.vagas"
                                        @change="handleBlurVagas"
                                    />
                                </rkm-col>

                                <rkm-col class="flex-grow-1">
                                    <rkm-form-input
                                        ref="tempoAtendimento"
                                        label="Tempo de atendimento"
                                        v-model="jornada.tempoAtendimento"
                                        :disabled="selecionados == false || !jornada.vagas || !jornada.horaInicial"
                                        @change="handleBlurTempoAtendimento"
                                    >
                                        <rkm-input-group-append slot="append">
                                            <rkm-input-group-text>
                                                em minutos.
                                            </rkm-input-group-text>
                                        </rkm-input-group-append>
                                    </rkm-form-input>
                                </rkm-col>

                                <rkm-col cols="auto">
                                    <rkm-button
                                        :label="false"
                                        @click.stop="resetForm"
                                        color="secondary"
                                        class="float-right"
                                        :disabled="selecionados == false"
                                    >
                                        Limpar
                                    </rkm-button>

                                    <rkm-button
                                        :label="false"
                                        @click.stop="atribuir()"
                                        color="primary"
                                        class="mr-2 float-right"
                                        :disabled="selecionados == false"
                                    >
                                        Atribuir
                                    </rkm-button>
                                </rkm-col>
                            </rkm-row>
                        </rkm-form>
                    </rkm-area>
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="model.jornadasNotSave && model.jornadasNotSave.length > 0">
                <rkm-col>
                    <rkm-button
                        @click="selecionarTodos()"
                        color="primary"
                        class="mb-2"
                    >
                        <template v-if="selecionados == false">
                            Selecionar todos
                        </template>

                        <template v-else>
                            Desmarcar selecionado(s)
                        </template>
                    </rkm-button>

                    <template>
                        <rkm-button
                            v-if="selecionados == true"
                            @click="deletarSelecionados()"
                            color="danger"
                            class="mb-2"
                        >
                            Excluir selecionado(s)
                        </rkm-button>
                    </template>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-table
                        :fields="fields.tables.jornada"
                        :items="model.jornadasNotSave"
                        ref="Table"
                        sort-by="data"
                        hide-filters
                    >
                        <template v-slot:cell(data)="{ value }">
                            {{ value | formatDate }}
                        </template>

                        <template v-slot:cell(vagasApp)="row">
                            {{ row.item.vagasApp || '-' }}
                        </template>

                        <template v-slot:cell(tempoAtendimento)="row">

                            <template v-if="row.item.tempoAtendimento === null || row.item.tempoAtendimento === ''|| row.item.tempoAtendimento === 0">
                                -
                            </template>

                            <template v-else>
                                {{ row.item.tempoAtendimento }} minutos
                            </template>
                        </template>

                        <template v-slot:cell(checkbox)="{ item }">
                            <rkm-form-checkbox
                                v-model="item.selecionado"
                                @change="handleBlur"
                            />
                        </template>

                        <template v-slot:cell(actions)="{ item }">
                            <rkm-button
                                :id="uniqueId('show-btn')"
                                @click="$refs.Modal.open(item)"
                                color="primary"
                                title="Detalhamento"
                                small
                            >
                                <rkm-icon icon="search" />
                            </rkm-button>

                            <rkm-button
                                color="primary"
                                title="Editar"
                                small
                                @click.stop="$emit('handleAlter', clone(item))"
                            >
                                <rkm-icon icon="pen" />
                            </rkm-button>

                            <rkm-button
                                color="danger"
                                title="Excluir"
                                small
                                @click.stop="handleDestroy(item)"
                            >
                                <rkm-icon icon="trash" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-col>
            </rkm-row>
        </div>

        <Modal ref="Modal" />

    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, data, stringCase } from '@/mixins'

// Components.
import Buscar from '@/components/exame-imagem/jornada/components/buscar/Form'
import Modal from '@/components/exame-imagem/jornada/components/Modal'

// Formats.
import formats from '@/filters/formats'

// Moment.
import moment from 'moment'

// Enuns.
import tipoJornada from '@/enums/exame-imagem/tipoJornada'

export default {
    components:{ Buscar,  Modal },
    computed:{
        fields() {
            const columns = [
                { key: 'checkbox', label: '#', class: 'text-center' },
                { key: 'data', label: 'Data', class: 'col-max', sortable: true },
                { key: 'horaInicial', label: 'Início', sortable: true },
                { key: 'horaFim', label: 'Fim', sortable: true },
                { key: 'vagas', label: 'Vagas', sortable: true },
            ]

            if (this.form.habilitaAgendamentoApp) {
                columns.push(
                    { key: 'vagasApp', label: 'Vagas APP Cidadão', sortable: true },
                )
            }

            columns.push(
                { key: 'tempoAtendimento', label: 'Tempo de atendimento', sortable: true },
                { key: 'exameNome', label: 'Grupo de exame', sortable: true },
                { key: 'unidadeNome', label: 'Unidade', sortable: true },
                { key: 'prestadorNome', label: 'Prestador', sortable: true },
                { key: 'tipoNome', label: 'Tipo de jornada', sortable: true },
                { key: 'statusNome', label: 'Status', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' }
            )

            return { tables: { jornada: columns } }
        },
        infraestruturas() {

            this.handleUnidade()

            if (this.jornada.unidadeId) {

                let infraestruturaPrincipal = this.form.unidadesParametrizadas.find(u => u.unidadeId === this.jornada.unidadeId).infraestruturas

                    this.getPrincipal(infraestruturaPrincipal)

                return infraestruturaPrincipal
            }

            return []
        },
        grupoExames() {

            this.handlegrupoExame()

            return this.form.exames
        },
        prestadores() {

            this.handlePrestador()

            return this.form.prestadores
        },
        validations() {
            return {
                horaInicial: {
                    max_hour: this.getMaxHour()
                },
                horaFim: {
                    min_hour: this.getMinHour()
                },
                vagas: {
                    min_value: 1
                },
            }
        },
    },
    created() {

        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada'),
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
            parametrizacaoExame: this.getConectaSusRepository('exameImagem.parametrizacao')
        }
    },
    data:() => ({
        selecionados: false,
        reset: false,
        jornada: {
            jornadaId: null,
            data: null,
            exameId: null,
            exameNome: '',
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            diasSemana: null,
            semanaId: null,
            statusId: null,
            statusNome: '',
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            unidadeId: null,
            selecionado: false,
            unidadeNome: '',
            usuarioId: '',
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
        },
        enums: {
            tipoJornada
        },
        isReadOnly: false,
    }),
    filters: {
        formatDate: formats.formatDate
    },
    mixins: [ repository, error, object, data, stringCase ],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),

        validate() {
            return this.$refs.Form.validate()
        },
        handleDestroy(item) {

            if ((!item.agendamentos || item.agendamentos === 0) && !item.vinculos){

                const destroy = () => new Promise(resolve => {

                    const objId = this.model.jornadas.findIndex((obj => obj.jornadaId == item.jornadaId));

                    resolve(this.model.jornadas.splice(objId, 1))

                })
                .then(() => {

                    if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                        const objIndex = this.model.jornadasNotSave.findIndex((obj => obj.jornadaId == item.jornadaId));

                        this.model.jornadasNotSave.splice(objIndex, 1)
                    }

                    this.$emit('getDays', this.model.jornadas)
                    this.handleBlur()
                })

                this.showDeleteConfirmation(`Deseja realmente excluir essa jornada?`, destroy)

            } else { 

                this.showValidationNotification(`Não é possível excluir uma jornada que possua vínculos.` 
                        + ` Para verificar quais vínculos estão associados, acesse:`
                        + ` <strong>Exame de Imagem > Relatório > Relatório de Exame por Status</strong>.`)

            }
        },
        handleBlur(){

            let selecionado = false

            if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                this.model.jornadasNotSave.map(jornada => {

                    if (jornada.selecionado == true) {

                        selecionado = true
                    }
                })

            } else {

                this.model.jornadas.map(jornada => {

                    if (jornada.selecionado == true) {

                        selecionado = true
                    }
                })
            }

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        getCalendar() {

            this.$emit('getDays', this.model.jornadas)
        },
        getPrincipal(infraestruturaPrincipal) {

            let localAtendimento = infraestruturaPrincipal.find(u => u.principal === true)

            if(localAtendimento ){

                this.jornada.infraestruturaId = localAtendimento.id
            } else {

                this.jornada.infraestruturaId = null
            }
        },
        selecionarTodos(){

            if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                if(this.selecionados == true){

                    this.selecionados = false
                } else {

                    this.selecionados = true
                }

                this.model.jornadasNotSave.filter(jornada => jornada.jornadaId).forEach(element => {

                    if(!element.agendamentos){

                        if(this.selecionados == true){

                            element.selecionado = true

                        } else {

                            element.selecionado = false
                        }
                    }
                })

            } else {

                if(this.selecionados == true){

                    this.selecionados = false
                } else {

                    this.selecionados = true
                }

                this.model.jornadas.filter(jornada => jornada.jornadaId).forEach(element => {

                    if(!element.agendamentos){

                        if(this.selecionados == true){

                            element.selecionado = true

                        } else {

                            element.selecionado = false
                        }
                    }
                })
            }
        },
        deletarSelecionados(){

            if(this.selecionados == false){

                this.showAlert('É necessário selecionar uma jornada')

            } else {

                const destroy = async () => this.model.jornadas.filter(p => p.selecionado && p.agendamentos == 0)
                    .map(item => {

                        this.model.jornadas.splice(this.model.jornadas.indexOf(item),1)

                        if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                            this.model.jornadasNotSave.splice(this.model.jornadasNotSave.indexOf(item),1)
                        }

                        this.$emit('getDays', this.model.jornadas)
                        this.handleBlur()
                    })

                this.showDeleteConfirmation(`Somente as jornadas sem agendamentos serão excluídas. Tem certeza de que
                    deseja excluir as jornadas selecionadas que não possuem agendamentos?`, destroy)
            }
        },
        atribuir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    if(this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0){

                        let msg = ''

                        this.model.jornadasNotSave.map((item, index) => {

                            if(item.selecionado){

                                let jornadaInvalida = false

                                const existeJornada = this.model.jornadas.find((j, i) => {

                                    const horaInicial = moment(item.data.concat(' ', this.jornada.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                    const horaFinal = moment(item.data.concat(' ', this.jornada.horaFim), 'DD/MM/YYYY HH:mm:ss')

                                    let unidadeId = this.jornada.unidadeId

                                        if(!unidadeId){

                                            unidadeId = item.unidadeId
                                        }

                                    let infraestruturaId = this.jornada.infraestruturaId

                                        if(!infraestruturaId){

                                            infraestruturaId = item.infraestruturaId
                                        }

                                    let exameId = this.jornada.exameId

                                        if(!exameId){

                                            exameId = item.exameId
                                        }

                                    return index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaInicial).isBetween(
                                        moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                        moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                    )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaFinal).isBetween(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                        )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaInicial).isSame(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaFinal).isSame(
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(
                                            this.getFormatedDate(horaInicial, 'DD/MM/YYYY HH:mm')
                                        )
                                        .isBefore(
                                            j.data.concat(' ', j.horaInicial),
                                        )
                                        && moment(this.getFormatedDate(horaFinal, 'DD/MM/YYYY HH:mm'))
                                        .isAfter(
                                            j.data.concat(' ', j.horaFim),
                                        )
                                })

                                const verificaData = [item.data]
                                const verificaUnidade = [item.unidadeNome]

                                if(existeJornada){

                                    for( let i = 0; i < verificaData.length; i++) {

                                        msg = msg.concat('<br/> - ', verificaData[i], ' - Conflito de horário na unidade ',
                                        '<b>', verificaUnidade[i], '</b>')
                                    }
                                }

                                var horaInicial = this.jornada.horaInicial

                                if (!horaInicial) {

                                    horaInicial = item.horaInicial
                                }

                                var horaFim = this.jornada.horaFim

                                if (!horaFim) {

                                    horaFim = item.horaFim
                                }

                                if (horaFim && horaInicial > horaFim) {

                                    jornadaInvalida = true

                                    let dataFormatada = item.data.substr(8, 2) + '/' + item.data.substr(5, 2) + '/' + item.data.substr(0, 4)

                                    msg = msg.concat('<br/> - ', dataFormatada ,' - Horário inicial maior que o horário final na unidade ',
                                        '<b>', item.unidadeNome, '.</b>')
                                }

                                if (item.primeiroHorario && horaInicial > item.primeiroHorario) {

                                    jornadaInvalida = true

                                    let dataFormatada = item.data.substr(8, 2) + '/' + item.data.substr(5, 2) + '/' + item.data.substr(0, 4)

                                    msg = msg.concat('<br/> - ', dataFormatada ,' - Horário inicial maior que o primeiro horário agendado para data na unidade  ',
                                        '<b>', item.unidadeNome, '.</b>')
                                }

                                var vagas = this.jornada.vagas

                                if (!vagas) {

                                    vagas = item.vagas
                                }

                                var unidadeId = this.jornada.unidadeId

                                if (!unidadeId) {

                                    unidadeId = item.unidadeId
                                }

                                var infraestruturaId = this.jornada.infraestruturaId

                                if (!infraestruturaId) {

                                    infraestruturaId = item.infraestruturaId
                                }

                                var exameId = this.jornada.exameId

                                if (!exameId) {

                                    exameId = item.exameId
                                }

                                var statusId = this.jornada.statusId

                                if (!statusId) {

                                    statusId = item.statusId
                                }

                                var tipoId = this.jornada.tipoId

                                if (!tipoId) {

                                    tipoId = item.tipoId
                                }

                                if(!existeJornada && !jornadaInvalida){

                                    var timeFim = horaFim.substr(0, 5)
                                    horaInicial = horaInicial.substr(0, 5)

                                    var inicioFim = horaInicial.split(':')
                                    var finalFim = timeFim.split(':')

                                    var inicioTratadoF = parseInt(inicioFim[0]* 60) + parseInt(inicioFim[1])
                                    var finalTratadoF = parseInt(finalFim[0]* 60) + parseInt(finalFim[1])

                                    var diferencaMinutosF = finalTratadoF - inicioTratadoF

                                    if(this.jornada.unidadeId){

                                        item.unidadeId =  this.jornada.unidadeId
                                    }

                                    if(this.jornada.unidadeId){

                                        item.unidadeNome = this.form.unidadesParametrizadas
                                            .find(u => u.unidadeId === this.jornada.unidadeId)
                                            .nomeFantasia
                                    }

                                    if(this.jornada.infraestruturaId){

                                        item.infraestruturaId = this.jornada.infraestruturaId
                                    }

                                    if(this.jornada.infraestruturaId){

                                        item.infraestruturaNome = this.infraestruturas
                                            .find(i => i.id === this.jornada.infraestruturaId)
                                            .nome
                                    }

                                    if(this.jornada.exameId){

                                        item.exameId = this.jornada.exameId
                                    }

                                    if(this.jornada.exameId){

                                        item.exameNome = this.form.exames
                                            .find(e => e.id === this.jornada.exameId)
                                            .nome
                                    }

                                    if(this.jornada.statusId){

                                        item.statusId =  this.jornada.statusId
                                    }

                                    if(this.jornada.statusId){

                                        item.statusNome = this.form.status
                                            .find(s => s.id === this.jornada.statusId)
                                            .nome
                                    }

                                    if(this.jornada.prestadorId){

                                        item.prestadorId =  this.jornada.prestadorId
                                    }

                                    if(this.jornada.prestadorId){

                                        item.prestadorNome = this.form.prestadores
                                            .find(s => s.prestadorId === this.jornada.prestadorId)
                                            .nomeFantasia
                                    }

                                    if(this.jornada.tipoId){

                                        item.tipoId =  this.jornada.tipoId
                                    }

                                    if(this.jornada.tipoId){

                                        item.tipoNome = this.form.tipos
                                            .find(s => s.id === this.jornada.tipoId)
                                            .nome
                                    }

                                    if(vagas && horaInicial && timeFim){

                                        item.tempoAtendimento = Math.floor(diferencaMinutosF / vagas)
                                    }

                                    if(this.jornada.horaInicial){

                                        item.horaInicial =  horaInicial
                                    }

                                    if(this.jornada.horaFim){

                                        item.horaFim =  timeFim
                                    }

                                    if(this.jornada.vagas){

                                        item.vagas = this.jornada.vagas
                                    }

                                    if(this.jornada.tempoAtendimento){

                                        item.tempoAtendimento = this.jornada.tempoAtendimento
                                    }
                                }

                                this.mensagemConflito(msg)
                                this.$emit('getCalendar')
                            }
                        })

                        this.resetForm()

                    } else {

                        let msg = ''

                        this.model.jornadas.map((item, index) => {

                            if(item.selecionado){

                                const existeJornada = this.model.jornadas.find((j, i) => {

                                    const horaInicial = moment(item.data.concat(' ', this.jornada.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                    const horaFinal = moment(item.data.concat(' ', this.jornada.horaFim), 'DD/MM/YYYY HH:mm:ss')

                                    let unidadeId = this.jornada.unidadeId

                                        if(!unidadeId){

                                            unidadeId = item.unidadeId
                                        }

                                    let infraestruturaId = this.jornada.infraestruturaId

                                        if(!infraestruturaId){

                                            infraestruturaId = item.infraestruturaId
                                        }

                                    let exameId = this.jornada.exameId

                                        if(!exameId){

                                            exameId = item.exameId
                                        }

                                    return index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaInicial).isBetween(
                                        moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                        moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                    )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaFinal).isBetween(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm'),
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm')
                                        )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaInicial).isSame(
                                            moment(j.data.concat(' ', j.horaInicial), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(horaFinal).isSame(
                                            moment(j.data.concat(' ', j.horaFim), 'DD/MM/YYYY HH:mm:ss')
                                        )
                                    || index !== i
                                        && j.unidadeId == unidadeId
                                        && j.infraestruturaId == infraestruturaId
                                        && j.exameId == exameId
                                        && moment(
                                            this.getFormatedDate(horaInicial, 'DD/MM/YYYY HH:mm')
                                        )
                                        .isBefore(
                                            j.data.concat(' ', j.horaInicial),
                                        )
                                        && moment(this.getFormatedDate(horaFinal, 'DD/MM/YYYY HH:mm'))
                                        .isAfter(
                                            j.data.concat(' ', j.horaFim),
                                        )
                                })

                                const verificaData = [item.data]

                                if(existeJornada){

                                    for( let i = 0; i < verificaData.length; i++) {

                                        msg = msg.concat('<br/> - ', verificaData[i], ' - Conflito de horário.')
                                    }
                                }

                                var horaInicial = this.jornada.horaInicial

                                if (!horaInicial) {

                                    horaInicial = item.horaInicial
                                }

                                var horaFim = this.jornada.horaFim

                                if (!horaFim) {

                                    horaFim = item.horaFim
                                }

                                var vagas = this.jornada.vagas

                                if (!vagas) {

                                    vagas = item.vagas
                                }

                                var unidadeId = this.jornada.unidadeId

                                if (!unidadeId) {

                                    unidadeId = item.unidadeId
                                }

                                var infraestruturaId = this.jornada.infraestruturaId

                                if (!infraestruturaId) {

                                    infraestruturaId = item.infraestruturaId
                                }

                                var exameId = this.jornada.exameId

                                if (!exameId) {

                                    exameId = item.exameId
                                }

                                var statusId = this.jornada.statusId

                                if (!statusId) {

                                    statusId = item.statusId
                                }


                                var tipoId = this.jornada.tipoId

                                if (!tipoId) {

                                    tipoId = item.tipoId
                                }

                                if(!existeJornada){

                                    var timeFim = horaFim.substr(0, 5)
                                    horaInicial = horaInicial.substr(0, 5)

                                    var inicioFim = horaInicial.split(':')
                                    var finalFim = timeFim.split(':')

                                    var inicioTratadoF = parseInt(inicioFim[0]* 60) + parseInt(inicioFim[1])
                                    var finalTratadoF = parseInt(finalFim[0]* 60) + parseInt(finalFim[1])

                                    var diferencaMinutosF = finalTratadoF - inicioTratadoF

                                    if(this.jornada.unidadeId){

                                        item.unidadeId =  this.jornada.unidadeId
                                    }

                                    if(this.jornada.unidadeId){

                                        item.unidadeNome = this.form.unidadesParametrizadas
                                            .find(u => u.unidadeId === this.jornada.unidadeId)
                                            .nomeFantasia
                                    }

                                    if(this.jornada.infraestruturaId){

                                        item.infraestruturaId = this.jornada.infraestruturaId
                                    }

                                    if(this.jornada.infraestruturaId){

                                        item.infraestruturaNome = this.infraestruturas
                                            .find(i => i.id === this.jornada.infraestruturaId)
                                            .nome
                                    }

                                    if(this.jornada.exameId){

                                        item.exameId = this.jornada.exameId
                                    }

                                    if(this.jornada.exameId){

                                        item.exameNome = this.form.exames
                                            .find(e => e.id === this.jornada.exameId)
                                            .nome
                                    }

                                    if(this.jornada.statusId){

                                        item.statusId =  this.jornada.statusId
                                    }

                                    if(this.jornada.statusId){

                                        item.statusNome = this.form.status
                                            .find(s => s.id === this.jornada.statusId)
                                            .nome
                                    }

                                    if(vagas && horaInicial && timeFim){

                                        item.tempoAtendimento = Math.floor(diferencaMinutosF / vagas)
                                    }

                                    if(this.jornada.horaInicial){

                                        item.horaInicial =  horaInicial
                                    }

                                    if(this.jornada.horaFim){

                                        item.horaFim =  timeFim
                                    }

                                    if(this.jornada.vagas){

                                        item.vagas = this.jornada.vagas
                                    }

                                    if(this.jornada.tempoAtendimento){

                                        item.tempoAtendimento = this.jornada.tempoAtendimento
                                    }

                                    if(this.jornada.tipoId){

                                        item.tipoId =  this.jornada.tipoId
                                    }

                                    if(this.jornada.tipoId){

                                        item.tipoNome = this.form.tipos
                                            .find(s => s.id === this.jornada.tipoNome)
                                            .nome
                                    }
                                }
                            }
                        })

                        this.mensagemConflito(msg)
                        this.resetForm()
                        this.$emit('getCalendar')
                   }
                })
        },
        mensagemConflito(msg){

            if(msg){

                this.showAlert('Não foi possível cadastrar a jornada nas seguintes datas: '  + msg, 'Atenção')
            }
        },
        resetForm() {

            this.jornada.vagas = ''
            this.jornada.statusId = null
            this.jornada.horaInicial = ''
            this.jornada.horaFim = ''
            this.jornada.unidadeId = null
            this.jornada.infraestruturaId = null
            this.jornada.exameId = null
            this.jornada.tipoId = null
            this.jornada.tempoAtendimento = null
        },
        handlegrupoExame() {

            const handlegrupoExame = this.form.exames

            if (handlegrupoExame && handlegrupoExame.length === 1) {

                this.jornada.exameId = handlegrupoExame[0].id
            }
        },
        handlePrestador() {

            const prestadores = this.form.prestadores

            if (prestadores && prestadores.length === 1) {

                this.jornada.prestadorId = prestadores[0].prestadorId
            }
        },
        handleUnidade() {

            const unidades = this.form.unidadesParametrizadas

            if (unidades && unidades.length === 1) {

                this.jornada.unidadeId = unidades[0].unidadeId
            }
        },
        handleBlurVagas(){

            const jornada = this.jornada

            jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
            jornada.horaFim = this.jornada.horaFim.substr(0, 5)

            let inicioHoraHandle = jornada.horaInicial.split(':')
            let fimHoraHandle = jornada.horaFim.split(':')

            let inicioTratado = parseInt(inicioHoraHandle[0]* 60) + parseInt(inicioHoraHandle[1])
            let finalTratado = parseInt(fimHoraHandle[0]* 60) + parseInt(fimHoraHandle[1])

            let diferencaMinutos = finalTratado - inicioTratado

            if(jornada.vagas <= 0){

                this.showValidationNotification("É necessário ter no mínimo uma vaga.")
                this.jornada.vagas = ''
                this.jornada.tempoAtendimento = ''
                return
            }

            if(jornada.vagas && this.jornada.horaInicial && this.jornada.horaFim){

                jornada.tempoAtendimento = Math.floor(diferencaMinutos / jornada.vagas)
            }

        },
        handleBlurHoraFim(){

            const jornada = this.jornada

            if (this.jornada.horaInicial) {

                jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
            } else {

                jornada.tempoAtendimento = null
            }

            if (this.jornada.horaFim) {

                jornada.horaFim = this.jornada.horaFim.substr(0, 5)
            }

            if (this.jornada.horaInicial && this.jornada.horaFim) {

                var inicioHoraHandle = jornada.horaInicial.split(':')
                var fimHoraHandle = jornada.horaFim.split(':')

                var inicioTratado = parseInt(inicioHoraHandle[0]* 60) + parseInt(inicioHoraHandle[1])
                var finalTratado = parseInt(fimHoraHandle[0]* 60) + parseInt(fimHoraHandle[1])

                var diferencaMinutos = finalTratado - inicioTratado

                if(jornada.vagas && this.jornada.horaInicial && this.jornada.horaFim){

                    jornada.tempoAtendimento = Math.floor(diferencaMinutos / jornada.vagas)
                }
            }
        },
        handleBlurTempoAtendimento(){

            const jornada = this.jornada

            jornada.horaInicial = this.jornada.horaInicial.substr(0, 5)
            jornada.tempoAtendimento = this.jornada.tempoAtendimento

            let totalMinutos = jornada.tempoAtendimento*jornada.vagas

            if(jornada.vagas <= 0){

                this.showValidationNotification("É necessário ter no mínimo uma vaga.")
                this.jornada.vagas = ''
                this.jornada.tempoAtendimento = ''
                return
            }

            if (this.jornada.tempoAtendimento) {

                var horarioFinal = moment(jornada.horaInicial, "HH:mm")
                    .add(totalMinutos, 'minutes')
                    .format('HH:mm');

                jornada.horaFim = horarioFinal
            }
        },
        getMaxHour() {

            const horario = this.jornada.horaFim

            if (horario) {

                return moment(horario, 'HH:mm').subtract(1, 'minutes').format('HH:mm')
            }

            return false
        },
        getMinHour() {

            const horario = this.jornada.horaInicial

            if (horario) {

                return moment(horario, 'HH:mm').add(1, 'minutes').format('HH:mm')
            }

            return false
        },
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        profissional: { type: Object, required: true},
    },
}
</script>